import React from 'react';
import { Field } from 'redux-form';
import { isRequired } from '../../lib/forms/Validations';
import {
  InputDateTime,
  InputRadioWithField,
  TimeSelect
} from '../../lib/forms';
import OptionsForwardedTo from './OptionsForwardedTo';
import moment from 'moment';
const ActiveMispari = (wasAlreadyForwardedTo, translate, values) => {
  const startField = values && values.start && values.start == 'option2' ? moment(values.startField, 'DD-MM-YYYY') : moment();
  return(
    <div className="">
      <div className="form-group mispari-border row" >
        <div className="col-md-7 font-weight-bold">
          <label >{translate('which-number-forward-calls')}</label>
        </div>
        <div className="custom-controls-stacked mispari-field col-md-5">
          <Field  name="forwardNumber"  component={OptionsForwardedTo} wasAlreadyForwardedTo={wasAlreadyForwardedTo} type="radio"  validate={[ isRequired]} />
        </div>
      </div>
      <Field name="start" className="form-group" radioName="start" placeholder={translate("select-date")} label={translate('choose-start-date-time-mispari')} component={InputRadioWithField} min={moment()} option1={translate('mispari-start-now')} type="date" validate={[ isRequired]}/>
      <div className="form-group mispari-border row">
        <div className="col-md-7 font-weight-bold">
          <label>{translate('choose-end-date-time-mispari')}<small className="text-muted ml-1">{`(${translate('optional')})`}</small></label>
        </div>
        <Field radioName="end" label="nom" className="form-control" neverDisable placeholder={translate("select-date")} values={values} component={InputDateTime} min={startField} name={'endField'} type="date" />
        <Field radioName="end" label="nom" className="form-control" neverDisable component={TimeSelect} name={'endTimeField'} values={values} type="time" />
      </div>

      <div className="form-group row form-group-warning">
        <div className="col">
          <small className="form-text text-muted">
            <strong>{translate('important-information')}:</strong>
            <span className="ml-1">
              {translate('important-information-message-active-mispari')}
            </span>
          </small>
        </div>
      </div>
    </div>
  )
}
export default ActiveMispari;



// WEBPACK FOOTER //
// ./src/components/Mispari/ActiveMispari.js